import React, { useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../redux/configureStore';
import Wrapper from '../../../../shared/components/Wrapper';
import BoletoDashboard from './components/BoletoDashboard';
import CartaoDashboard from './components/CartaoDashboard';
import CriptoDashboard from './components/CriptoDashboard';
import DomicilioDashboard from './components/DomicilioDashboard';
import FaresFilter from './components/FaresFilter';
import Frame from './components/Frame';
import IncomeDashboard from './components/IncomeDashboard';
import MonthlyDashboard from './components/MonthlyDashboard';
import PixDashboard from './components/PixDashboard';
import SlbDashboard from './components/SlbDashboard';
import TedDashboard from './components/TedDashboard';
import TevDashboard from './components/TevDashboard';
import TibDashboard from './components/TibDashboard';

function FaresApp() {
  const tedFaresState = useSelector((reducer: IReducer) => reducer.tedFares);
  const tibFaresState = useSelector((reducer: IReducer) => reducer.tibFares);
  const slbFaresState = useSelector((reducer: IReducer) => reducer.slbFares);
  const pixFaresState = useSelector((reducer: IReducer) => reducer.pixFares);
  const boletoFaresState = useSelector(
    (reducer: IReducer) => reducer.boletoFares
  );
  const monthlyFaresState = useSelector(
    (reducer: IReducer) => reducer.monthlyFares
  );
  const incomeFaresState = useSelector(
    (reducer: IReducer) => reducer.incomeFares
  );
  const criptoFaresState = useSelector(
    (reducer: IReducer) => reducer.criptoFares
  );
  const cartaoFaresState = useSelector(
    (reducer: IReducer) => reducer.cartaoFares
  );
  const domicilioFaresState = useSelector(
    (reducer: IReducer) => reducer.domicilioFares
  );
  const tevFaresState = useSelector((reducer: IReducer) => reducer.tevFares);

  const isLoading = useMemo(() => {
    if (
      tedFaresState.isLoading ||
      tibFaresState.isLoading ||
      slbFaresState.isLoading ||
      boletoFaresState.isLoading ||
      monthlyFaresState.isLoading ||
      incomeFaresState.isLoading ||
      criptoFaresState.isLoading ||
      cartaoFaresState.isLoading ||
      domicilioFaresState.isLoading ||
      tevFaresState.isLoading ||
      pixFaresState.isLoading
    ) {
      return (
        <Wrapper.Default margin="20% 0 0 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [
    tedFaresState.isLoading,
    tibFaresState.isLoading,
    slbFaresState.isLoading,
    boletoFaresState.isLoading,
    monthlyFaresState.isLoading,
    incomeFaresState.isLoading,
    criptoFaresState.isLoading,
    pixFaresState.isLoading,
    domicilioFaresState.isLoading,
    cartaoFaresState.isLoading,
  ]);

  return (
    <Frame.Base>
      <FaresFilter />
      {isLoading}
      <TedDashboard />
      <PixDashboard />
      <BoletoDashboard />
      <MonthlyDashboard />
      <TibDashboard />
      <SlbDashboard />
      <IncomeDashboard />
      <CriptoDashboard />
      <CartaoDashboard />
      <DomicilioDashboard />
      <TevDashboard />
    </Frame.Base>
  );
}

export default FaresApp;
